<!-- Item Start Outlet -->
<ng-template [cxOutlet]="CartOutlets.ITEM">
  <div class="row">
    <!-- Item Image -->
    <div
      class="favorites-item__left col-12 col-sm-7"
      [class]="'col-lg-7 favorites-item__left-favorites'"
    >
      <div class="row">
        <div class="eb-checkbox-container col-1">
          <input
            type="checkbox"
            (change)="onItemSelectChange(item, $event.target.checked)"
            [checked]="item.isSelected"
            [attr.data-cy]="'select-item-' + item.product.code"
          />
        </div>
        <div class="eb-image-container">
          <a
            *ngIf="item.product?.approved; else showImageWithoutLink"
            [routerLink]="'/v/' + item.product.code | cxUrl"
            cxModal="dismiss"
            tabindex="-1"
          >
            <cx-media
              [container]="item.product.images?.PRIMARY"
              [alt]="item.product.name"
              format="cartIcon"
            ></cx-media>
          </a>
        </div>
        <ng-template #showImageWithoutLink>
          <cx-media
            [container]="item.product.images?.PRIMARY"
            [alt]="item.product.name"
            format="cartIcon"
          ></cx-media>
        </ng-template>
        <div class="cx-info-container col-7 col-sm-9">
          <!-- Item Description -->
          <div class="cx-name">
            <a
              *ngIf="item.product?.approved; else showTitleWithoutLink"
              class="cx-link"
              [routerLink]="'/v/' + item.product.code | cxUrl"
              cxModal="dismiss"
              [attr.data-cy]="'variant-link-' + item.product.code"
            ><h2>{{ item.product?.name || item.product.code }}</h2></a
            >
          </div>
          <ng-template #showTitleWithoutLink>
            <h2>{{ item.product?.name || item.product.code }}</h2>
          </ng-template>

          <!-- AVAILABILITY -->
          <ng-container *ngIf="item.product?.orderable">
            <ng-container *ngIf="availabilityLoading; else availabilityTemplate">
              <eb-spinner class="product-detail__availability-spinner" size="1"></eb-spinner>
            </ng-container>
            <ng-template #availabilityTemplate>
              <eb-product-availability
                *ngIf="availabilityItem"
                [availability]="availabilityItem"
                [error]="availabilityError"
                [attr.data-cy]="'availability_' + item.product.code"
              ></eb-product-availability>
            </ng-template>
          </ng-container>

          <div *ngIf="item.product?.code" class="cx-code" data-cy="material-code">
            {{ 'cartItems.id' | cxTranslate }} {{ item.product.code }}
          </div>
          <div *ngIf="item.product?.customerMaterialNumber" class="cx-code" data-cy="material-code">
            {{ 'cartItems.customerMaterialNumber' | cxTranslate }}
            {{ item.product.customerMaterialNumber }}
          </div>
          <div *ngIf="item.creationTime" class="cx-code" data-cy="addition-time">
            {{ 'cartItems.additionTime' | cxTranslate }} {{ item.creationTime | cxDate: 'mediumDate' : 'UTC' }}
          </div>
          <div *ngIf="item?.savedBy?.name" class="cx-code" data-cy="saved-by">
            {{ 'cartItems.addedBy' | cxTranslate }} {{ item?.savedBy?.name }}
          </div>
          <eb-product-sales-text
            [cssClass]="'eb-favorites-item'"
            [salesText]="item?.product?.productSalesView?.salesText"
          ></eb-product-sales-text>
        </div>
      </div>
    </div>
    <!-- Item Information -->
    <ng-container *ngIf="item?.product.orderable">
      <div class="favorites-item__right col-12 col-sm-4" [class]="'col-lg-7'">
        <div class="row eb-favorites-item__right-info" [class.price-less]="!showPrice">
          <!-- Item Unit -->
          <div
            class="cx-unit"
            [ngClass]="{
              'col-lg-3': hideQuantity,
              'col-lg-2': !hideQuantity
            }"
          >
            <div class="cx-label d-block d-lg-none d-xl-none">
              {{ 'cartItems.unit' | cxTranslate }}
            </div>
            <div *ngIf="(priceItem$ | async)" class="cx-value">
              {{ item?.unit }}
            </div>
          </div>
          <!-- Item Price -->
          <div
            *ngIf="(priceItem$ | async)"
            class="cx-price"
            [ngClass]="'col-lg-3 favorites-item__right-favorites'"
          >
            <div class="cx-label d-block d-lg-none d-xl-none">
              {{ 'cartItems.itemPrice' | cxTranslate }}
            </div>
            <div class="cx-value text-right" data-cy="fav-item-price">
              {{
                (priceItem$ | async).value > 0
                  ? (priceItem$ | async).formattedValue
                  : ('cartItems.priceOnRequest' | cxTranslate)
              }}
            </div>
          </div>
        </div>

        <!-- Item Bundle Details Outlet -->
        <ng-template [cxOutlet]="CartOutlets.ITEM_BUNDLE_DETAILS"></ng-template>
      </div>
    </ng-container>
  </div>

  <!-- Comment -->
  <div class="row">
    <div class="eb-favorites-item__comment">
      <ng-container
        *ngIf="isEditMode || item.comment === '' || item.comment === undefined; else showTitleOnly"
      >
        <textarea #entryComment [placeholder]="'cartItems.comment' | cxTranslate">{{
            item.comment
          }}</textarea>
        <div class="eb-favorites-item__comment-actions">
          <button class="link eb-favorites-item__comment-save" (click)="updateCommentOnEntry(item)">
            {{ 'favorites.commentSave' | cxTranslate }}
          </button>
          <button
            class="link eb-favourites-item__comment-remove"
            (click)="deleteCommentOnEntry(item)"
          >
            {{ 'common.remove' | cxTranslate }}
          </button>
        </div>
      </ng-container>
      <ng-template #showTitleOnly>
        <div class="eb-favorites-item__comment-show">
          {{ item.comment }}
        </div>
        <div class="eb-favorites-item__comment-actions">
          <button class="link eb-favorites-item__comment-edit" (click)="toggleEditableState()">
            <em class="fas fa-pen"></em>
            {{ 'favorites.commentEdit' | cxTranslate }}
          </button>
          <button
            class="link eb-favourites-item__comment-remove"
            (click)="deleteCommentOnEntry(item)"
          >
            {{ 'common.remove' | cxTranslate }}
          </button>
        </div>
      </ng-template>
    </div>
  </div>

  <!-- Actions -->
  <div class="row eb-favorites-item__right-actions">
    <div class="eb-favorites-item__actions">
      <div class="eb-favorites-item__remove">
        <button
          class="eb-remove-favorites-item__button"
          data-cy="remove-from-list"
          (click)="removeFavoritesItem(item.product.code)"
        >
          {{ 'favorites.item.remove' | cxTranslate }}
          <span class="fas fa-star"></span>
        </button>
      </div>
      <ng-container *ngIf="showAddToCart">
        <ng-container *ngIf="priceLoading; else showPriceSection">
          <eb-spinner class="eb-favorites-item__price-spinner" size="2"></eb-spinner>
        </ng-container>
        <ng-template #showPriceSection>
          <ng-container
            *ngIf="(priceItem$ | async)?.value > 0 || hasSuccessor(item?.product); else showRequestQuote"
          >
            <div class="eb-favorites-item__add-to-cart">
              <eb-purchase-product
                [product]="
                  hasSuccessor(item?.product) && !item?.product.orderable
                    ? item?.product.successor
                    : item?.product
                "
                [isAvailable]="
                  hasSuccessor(item?.product)
                    ? item?.product.successor?.orderable
                    : item?.product.orderable
                "
                [showSuccessor]="hasSuccessor(item?.product) && !item?.product.orderable"
                [showQuantity]="false"
                [showCountOfProductInCart]="true"
                [favoritesView]="true"
                [isVariantProduct]="item?.product.ebProductType"
              ></eb-purchase-product>
            </div>
          </ng-container>
          <ng-template #showRequestQuote>
            <div class="eb-favorites-item__add-to-cart">
              <a
                class="eb-favorites-item__request-quote-btn"
                [attr.data-cy]="'request-link-' + item?.product.code"
                [routerLink]="['/rfp']"
                [queryParams]="{
                  productCode: item?.product.code,
                  productName: item?.product.name
                }"
                (click)="requestRfpEvent(item?.product.code)"
              >
                {{ 'requestQuote.sendRequest' | cxTranslate }} <em class="fas fa-file-alt"></em>
              </a>
            </div>
          </ng-template>
        </ng-template>
      </ng-container>
    </div>
  </div>

  <ng-container *ngIf="item?.product as product">
    <div *ngIf="!product.orderable" class="row eb-favorites-item__orderable">
      <eb-info-box
        *ngIf="product.successor; else rfpLink"
        icon="info-circle"
        infoType="INFO"
        class="col-lg-8"
      >
        <span>{{ 'cartItems.hasSuccessorProductText' | cxTranslate }} </span>
        <a
          class="eb-replacement-link"
          [routerLink]="getSuccessorLink(product.successor.code)"
          [attr.data-cy]="'successor-link-' + product.successor.code"
        >{{ product.successor.code }} - {{ product.successor.name }}
        </a>
      </eb-info-box>
      <ng-template #rfpLink>
        <eb-info-box icon="exclamation-triangle" infoType="DANGER-LIGHT" class="col-lg-8">
          <span>{{ 'cartItems.nonPurchasableText' | cxTranslate }} </span>
          <a
            class="eb-replacement-link"
            [routerLink]="['/rfp']"
            [queryParams]="{ productCode: product.code, productName: product.name }"
          >{{ 'cartItems.nonPurchasableRfpLink' | cxTranslate }}
          </a>
        </eb-info-box>
      </ng-template>
    </div>
  </ng-container>
</ng-template>
